const coreConfig = {
  pu: {
    development: import.meta.env.VITE_APP_API_URL || "http://localhost:5007/",
    production: import.meta.env.VITE_APP_API_URL,
  },
  socket: {
    development:
      import.meta.env.VITE_APP_API_SOCKET_URL || "http://localhost:5007/",
    production: import.meta.env.VITE_APP_API_SOCKET_URL,
  },
};

export default coreConfig;

// console.log(import.meta.env.VITE_APP_API_URL)
